import INVENTORY_API_BASE_URL from "../../config/api";
import React, { useState, useEffect } from "react";
import "./CreateShipmentnew.css";
import { Table } from "react-bootstrap";
import Axios from "axios";
import { useNavigate } from "react-router-dom";

const CreateShipmentnew = () => {
  const [data, setData] = useState([]);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalWeight, setTotalWeight] = useState(0);
  const [selectedShipments, setSelectedShipments] = useState([]);
  const [inputValues, setInputValues] = useState({});
  const [selectedShipmentId, setSelectedShipmentId] = useState(null);
  const [checkboxStatus, setCheckboxStatus] = useState({});
  const [isCreatingShipment, setIsCreatingShipment] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10;
  const filteredData = data.filter((row) => Boolean(row.ApprovalDate));
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);


  function formatDate(dateString) {
    const date = new Date(dateString);
    const options = { day: "numeric", month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }

  useEffect(() => {
    Axios.get(`${INVENTORY_API_BASE_URL}/getshipment`).then(
      (response) => {
        const latest30Data = response.data;
        setData(latest30Data);
      }
    );
  }, []);


  const navigate = useNavigate();

  const handleInputChange = (shipmentid, value) => {
    setInputValues((prevInputValues) => ({
      ...prevInputValues,
      [shipmentid]: value,
    }));
  };

  const handleCheckboxChange = (shipmentid) => {
    setCheckboxStatus((prevStatus) => ({
      ...prevStatus,
      [shipmentid]: !prevStatus[shipmentid], 
    }));
    if (selectedShipments.includes(shipmentid)) {
      setSelectedShipments((prevSelected) =>
        prevSelected.filter((id) => id !== shipmentid)
      );
    } else {
      setSelectedShipments((prevSelected) => [...prevSelected, shipmentid]);
    }
  };

  const getSelectedShipmentData = () => {
    const selectedData = [];

    const selectedShipmentIds = new Set();

    filteredData.forEach((row) => {
      if (selectedShipments.includes(row.shipmentid)) {
        const inputValue = inputValues[row.shipmentid] || "";

        row.updatedQuantity.forEach((item) => {
          const totalValue = (item.approvedquantity * item.weight) / 1000;

          if (!selectedShipmentIds.has(row.shipmentid)) {
            selectedShipmentIds.add(row.shipmentid);

            const shipmentData = {
              orderId: row.shipmentid,
              numberOfBoxes: parseInt(inputValue),
              OrderDetails: [
                {
                  title: item.title,
                  Medium: item.Medium,
                  edition: item.edition,
                  sku: item.sku,
                  approvedquantity: item.approvedquantity,
                  weight: item.weight,
                  totalBookWeight: totalValue,
                },
              ],
            };
            selectedData.push(shipmentData);
          } else {
            selectedData[selectedData.length - 1].OrderDetails.push({
              title: item.title,
              Medium: item.Medium,
              edition: item.edition,
              sku: item.sku,
              approvedquantity: item.approvedquantity,
              weight: item.weight,
              totalBookWeight: totalValue,
            });
          }
        });
      }
    });
    return selectedData;
  };

  const calculateTotalQuantity = () => {
    let totalQuantity = 0;

    selectedShipments.forEach((shipmentId) => {
      const shipmentData = filteredData.find(
        (row) => row.shipmentid === shipmentId
      );

      if (shipmentData) {
        shipmentData.updatedQuantity.forEach((item) => {
          totalQuantity += item.approvedquantity;
        });
      }
    });

    return totalQuantity;
  };

  const calculateTotalWeight = () => {
    let totalWeight = 0;

    selectedShipments.forEach((shipmentId) => {
      const shipmentData = filteredData.find(
        (row) => row.shipmentid === shipmentId
      );

      if (shipmentData) {
        shipmentData.updatedQuantity.forEach((item) => {
          totalWeight += (item.approvedquantity * item.weight) / 1000;
        });
      }
    });
    return totalWeight;
  };

  const calculateTotalBoxes = () => {
    let totalBoxes = 0;
    selectedShipments.forEach((shipmentId) => {
      const inputValue = inputValues[shipmentId];
      if (inputValue) {
        totalBoxes += parseInt(inputValue);
      }
    });
    return totalBoxes;
  };
  const totalBoxes = calculateTotalBoxes();
  useEffect(() => {
    setTotalQuantity(calculateTotalQuantity());
    setTotalWeight(calculateTotalWeight());
  }, [selectedShipments, filteredData]);

  const handleCreateShipment = () => {
    if (selectedShipments.length === 0) {
      alert("At least select One Order ID");
      return;
    }
    const areAllInputsFilled = selectedShipments.every((shipmentId) => {
      return !!inputValues[shipmentId];
    });

    if (!areAllInputsFilled) {
      alert("Please fill in the number of boxes for all selected shipments.");
      return;
    }

    setIsCreatingShipment(true);

    const selectedShipmentData = getSelectedShipmentData();
    const shipmentData = {
      totalBoxes: totalBoxes,
      totalQuantity: totalQuantity,
      totalWeight: totalWeight,
      ShipmentDetails: selectedShipmentData.map((shipment) => ({
        orderId: shipment.orderId,
        numberOfBoxes: shipment.numberOfBoxes,
        OrderDetails: shipment.OrderDetails.map((orderDetail) => ({
          title: orderDetail.title,
          Medium: orderDetail.Medium,
          edition: orderDetail.edition,
          SKU: orderDetail.sku,
          approvedquantity: orderDetail.approvedquantity,
          totalBookWeight: orderDetail.totalBookWeight,
        })),
      })),
    };

    setSelectedShipments([]);
    setInputValues({});
    setSelectedShipmentId(null);

    const numRows = totalBoxes;
    navigate(`/Generated/${numRows}`, {
      state: { shipmentData },
    });
  };
  const selectedShipmentData = getSelectedShipmentData();

  const goToNextPage = () => {
    if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
  };

  const goToPreviousPage = () => {
    if (currentPage > 1) setCurrentPage((prev) => prev - 1);
  };
  return (
    <main className="shipment-page">
      <header className="shipment-hero">
        <div className="shipment-hero__copy">
          <p className="shipment-hero__eyebrow">Outbound · Shipment preparation</p>
          <h1>Create Shipment</h1>
          <p className="shipment-hero__description">
            Select approved orders, assign the number of boxes, and review the shipment contents before continuing.
          </p>
        </div>
        <div className="shipment-hero__note" aria-label="10 approved orders shown per page">
          <span className="shipment-hero__number">10</span>
          <span>
            <strong>Orders per page</strong>
            <small>Browse approved orders</small>
          </span>
        </div>
      </header>

      <section className="shipment-metrics" aria-label="Shipment overview">
        <article className="shipment-metric">
          <span className="shipment-metric__icon" aria-hidden="true">ALL</span>
          <span className="shipment-metric__copy">
            <span>Approved orders</span>
            <strong>{filteredData.length.toLocaleString()}</strong>
          </span>
        </article>
        <article className="shipment-metric shipment-metric--selected">
          <span className="shipment-metric__icon" aria-hidden="true">SEL</span>
          <span className="shipment-metric__copy">
            <span>Selected orders</span>
            <strong>{selectedShipments.length.toLocaleString()}</strong>
          </span>
        </article>
        <article className="shipment-metric shipment-metric--boxes">
          <span className="shipment-metric__icon" aria-hidden="true">▣</span>
          <span className="shipment-metric__copy">
            <span>Total boxes</span>
            <strong>{totalBoxes.toLocaleString()}</strong>
          </span>
        </article>
      </section>

      <section className="shipment-panel" aria-labelledby="approved-orders-heading">
        <div className="shipment-panel__header">
          <div>
            <p className="shipment-panel__eyebrow">Order selection</p>
            <h2 id="approved-orders-heading">Approved shipments</h2>
            <p className="shipment-panel__description">
              Select the orders to include and enter a box count for each one.
            </p>
          </div>
          <span className="shipment-record-count">
            {filteredData.length.toLocaleString()} {filteredData.length === 1 ? "order" : "orders"}
          </span>
        </div>

        <div className="shipment-pagination" aria-label="Approved shipment pagination">
          <span className="shipment-pagination__meta">
            Showing <strong>{filteredData.length === 0 ? 0 : indexOfFirstItem + 1}–{Math.min(indexOfLastItem, filteredData.length)}</strong>
            {" "}of <strong>{filteredData.length.toLocaleString()}</strong> approved orders
          </span>
          <div className="shipment-pagination__controls">
            <button
              type="button"
              onClick={goToPreviousPage}
              disabled={currentPage <= 1 || totalPages === 0}
              className="shipment-pagination-btn"
              aria-label="Go to previous page"
            >
              <span aria-hidden="true">←</span> Previous
            </button>
            <span className="shipment-page-count">
              Page {totalPages === 0 ? 0 : currentPage} of {totalPages}
            </span>
            <button
              type="button"
              onClick={goToNextPage}
              disabled={currentPage >= totalPages}
              className="shipment-pagination-btn"
              aria-label="Go to next page"
            >
              Next <span aria-hidden="true">→</span>
            </button>
          </div>
        </div>

        <div className="shipment-table-wrap">
          <Table className="shipment-table">
            <thead>
              <tr>
                <th scope="col">Select</th>
                <th scope="col">Order ID</th>
                <th scope="col">Distributor name</th>
                <th scope="col">Order date</th>
                <th scope="col">Boxes</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems.map((row) => (
                  <tr
                    key={row.shipmentid}
                    className={checkboxStatus[row.shipmentid] ? "shipment-row--selected" : undefined}
                  >
                    <td data-label="Select">
                      <input
                        className="shipment-checkbox"
                        type="checkbox"
                        checked={checkboxStatus[row.shipmentid] || false}
                        onChange={() => handleCheckboxChange(row.shipmentid)}
                        aria-label={`Select order ${row.shipmentid}`}
                      />
                    </td>
                    <td data-label="Order ID"><span className="shipment-order-id">{row.shipmentid}</span></td>
                    <td data-label="Distributor">{row.distributorName}</td>
                    <td data-label="Order date">{formatDate(row.orderdate)}</td>
                    <td data-label="Boxes">
                      <input
                        className="shipment-box-input"
                        name="boxes"
                        type="number"
                        min="1"
                        value={inputValues[row.shipmentid] || ""}
                        onChange={(e) => handleInputChange(row.shipmentid, e.target.value)}
                        required={selectedShipmentId === row.shipmentid}
                        aria-label={`Number of boxes for order ${row.shipmentid}`}
                      />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan={5}>
                    <div className="shipment-empty">
                      <strong>No approved shipments to show</strong>
                      <span>Approved orders will appear here when they are ready for shipment.</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </section>

      <section className="shipment-panel" aria-labelledby="selected-orders-heading">
        <div className="shipment-selected-heading">
          <div>
            <h2 id="selected-orders-heading">Selected order details</h2>
            <p>Review the items and quantities included in this shipment.</p>
          </div>
          <span className="shipment-record-count">
            {selectedShipmentData.length.toLocaleString()} {selectedShipmentData.length === 1 ? "order" : "orders"}
          </span>
        </div>

        <div className="shipment-table-wrap">
          <Table className="shipment-table shipment-selected-table">
            <thead>
              <tr>
                <th scope="col">Order ID</th>
                <th scope="col">Title</th>
                <th scope="col">SKU</th>
                <th scope="col">Medium</th>
                <th scope="col">Edition</th>
                <th scope="col">Quantity</th>
                <th scope="col">Boxes</th>
              </tr>
            </thead>
            <tbody>
              {selectedShipmentData.length > 0 ? (
                selectedShipmentData.map((shipment, index) => (
                  <React.Fragment key={`${shipment.orderId}-${index}`}>
                    {shipment.OrderDetails.map((orderDetail, detailIndex) => (
                      <tr key={`${shipment.orderId}-detail-${detailIndex}`}>
                        <td data-label="Order ID"><span className="shipment-order-id">{shipment.orderId}</span></td>
                        <td data-label="Title">{orderDetail.title}</td>
                        <td data-label="SKU">{orderDetail.sku}</td>
                        <td data-label="Medium">{orderDetail.Medium}</td>
                        <td data-label="Edition">{orderDetail.edition}</td>
                        <td data-label="Quantity">{orderDetail.approvedquantity}</td>
                        <td data-label="Boxes">{shipment.numberOfBoxes}</td>
                      </tr>
                    ))}
                  </React.Fragment>
                ))
              ) : (
                <tr>
                  <td colSpan={7}>
                    <div className="shipment-selected-empty">
                      <strong>No orders selected yet</strong>
                      <span>Select an approved order above to see its items and shipment quantities.</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
        <div className="shipment-summary" aria-label="Shipment totals">
          <div className="shipment-summary__item">
            <span>Total boxes</span>
            <strong>{totalBoxes.toLocaleString()}</strong>
          </div>
          <div className="shipment-summary__item">
            <span>Total quantity</span>
            <strong>{totalQuantity.toLocaleString()}</strong>
          </div>
          <div className="shipment-summary__item">
            <span>Total weight</span>
            <strong>{totalWeight.toLocaleString(undefined, { maximumFractionDigits: 2 })} kg</strong>
          </div>
        </div>
        <div className="shipment-actions">
          <p className="shipment-actions__hint">
            {selectedShipments.length === 0
              ? "Select at least one order and enter its box count to continue."
              : "Check the details above, then continue to generate shipment labels."}
          </p>
          <button
            type="button"
            className="button-7"
            onClick={handleCreateShipment}
            disabled={isCreatingShipment}
          >
            {isCreatingShipment ? "Creating Shipment..." : "Create Shipment"}
            {!isCreatingShipment && <span aria-hidden="true">→</span>}
          </button>
        </div>
        {isCreatingShipment && (
          <div className="shipment-loading" role="status" aria-live="polite">
            Creating your shipment and preparing the next step…
          </div>
        )}
      </section>
    </main>
  );
};

export default CreateShipmentnew;
